"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author ZSr
 * wrapper class output from baseline aggregation pipeline
 *
 */


var PromoBaselineOutput =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PromoBaselineOutput, _DomainObject_1$Domai);

  /**
   * @param productId the internal id of product
   * @param date
   * @param amount
   */
  function PromoBaselineOutput(productId, date, amount) {
    var _this;

    _classCallCheck(this, PromoBaselineOutput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromoBaselineOutput).call(this));
    _this.productId = productId;
    _this.date = date;
    _this.amount = amount;
    return _this;
  }

  return PromoBaselineOutput;
}(DomainObject_1.DomainObject);

exports.PromoBaselineOutput = PromoBaselineOutput;

PromoBaselineOutput.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PromoBaselineOutput.name);
  return {
    productId: builder.id('productId'),
    date: builder.date('date', DateParser_1.DateParser.ISO_PATTERN),
    amount: builder.num('amount')
  };
}();